import { LIST_QUERY_CACHE_TTL_SECONDS } from '../constants';
import { api } from '../core';
import type { ChatHistoryData } from './getChatHistory';

export interface GetMatterChatsRequest {
  matterId: string;
  limit?: number;
  titleKeyword?: string;
}

export interface GetMatterChatsResponse {
  chats: ChatHistoryData[];
}

export const getMatterChatsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMatterChats: builder.query<GetMatterChatsResponse, GetMatterChatsRequest>({
      query: ({ matterId, limit, titleKeyword }) => ({
        url: '/matter/chats',
        method: 'GET',
        params: {
          matterId,
          limit,
          ...(titleKeyword && { title_keywords: titleKeyword }),
        },
      }),
      keepUnusedDataFor: LIST_QUERY_CACHE_TTL_SECONDS,
    }),
  }),
});

export const { useGetMatterChatsQuery, useLazyGetMatterChatsQuery } = getMatterChatsApi;
